import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import { mask } from 'vue-the-mask'
import * as Sentry from '@sentry/vue'

const app = createApp(App)

Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
})

app
    .directive('mask', mask)
    .use(store)
    .use(router)
    .mount('#app')
